import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const STORY_IMG =
  "https://static.prod-images.emergentagent.com/jobs/7076c684-c2dc-44d5-b819-1abf0dd5cbeb/images/d0b3ca8054526920a985dc4155557eb0b13d1b89d310f48a9f022020c6d1a5e8.png";

export const StoryBlurb = () => {
  return (
    <section className="py-20 md:py-28 bg-jow-cream" data-testid="home-story">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-6"
        >
          <span className="label-overline text-jow-gold">Our Story</span>
          <h2 className="font-display text-4xl md:text-5xl mt-3 text-jow-navy leading-tight">
            From a Jaipur courtyard
            <span className="block italic text-jow-gold">to your living room.</span>
          </h2>
          <p className="mt-5 text-jow-navy/70 leading-relaxed max-w-lg">
            Three generations of karigars. Hand-finished pieces, ethically sourced.
            We carry the showroom to your doorstep on a fleet of e-rikshaws —
            inspect a piece in your sari, in your light, then decide.
          </p>
          <div className="mt-8 flex items-center gap-5">
            <Link to="/about" className="btn-secondary-jow" data-testid="story-cta">
              Read the full story
            </Link>
            <Quote size={20} className="text-jow-gold" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-6"
        >
          <div className="aspect-[5/4] overflow-hidden border border-jow-gold/40">
            <img
              src={STORY_IMG}
              alt="Hand-crafted Indian jewellery"
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
